const singleSelectTypes = {
  DEFAULT: 'DEFAULT',
  BUTTON: 'BUTTON'
};

export default singleSelectTypes;